module.exports = __webpack_public_path__ + "media/images/expert__bruno-berner-d75dd01e043b5106c1fd10746d4e6cce.png";